import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { IOrderClause } from '../../ServerApi/types/IOrderClause';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';
import { viewSortOptions, workbookNameSortOption } from './ViewSortOptions';

export const recentsSpaceDefaultSortOrder: IOrderClause[] = [Order.desc(OrderKeys.lastAccessedAt)];

export const recentsSortOptions: OptionsDictionary = {
    'name': SortOptions.name,
    /*TFSID:1020353 'workbook': workbookNameSortOption,*/
    'lastAccessedAt': {
      id: 'lastAccessedAt',
      getMenuItemDisplayValue: Messages.sortLastAccessedAt,
      subSortOptions: {
        'desc': {
          id: 'lastAccessedAt.desc',
          field: OrderKeys.lastAccessedAt,
          getMenuItemDisplayValue: Messages.sortByNewest,
          getButtonDisplayValue: Messages.sortLastAccessedAtNewest,
          ascending: false,
          toOrderClauseArray: () => [Order.desc(OrderKeys.lastAccessedAt)]
        },
        'asc': {
          id: 'lastAccessedAt.asc',
          field: OrderKeys.lastAccessedAt,
          getMenuItemDisplayValue: Messages.sortByOldest,
          getButtonDisplayValue: Messages.sortLastAccessedAtOldest,
          ascending: true,
          toOrderClauseArray: () => [Order.asc(OrderKeys.lastAccessedAt)]
        }
      }
    },
    'projectName': SortOptions.projectName,
    'owner': SortOptions.owner,
};

// to be removed with metricsSpaceEnabled feature flag
export const recentViewsOptions: OptionsDictionary = {
  ...viewSortOptions,
  'lastAccessedAt': {
    id: 'lastAccessedAt',
    getMenuItemDisplayValue: Messages.sortLastAccessedAt,
    subSortOptions: {
      'desc': {
        id: 'lastAccessedAt.desc',
        field: OrderKeys.lastAccessedAt,
        getMenuItemDisplayValue: Messages.sortByNewest,
        getButtonDisplayValue: Messages.sortLastAccessedAtNewest,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.lastAccessedAt)]
      },
      'asc': {
        id: 'lastAccessedAt.asc',
        field: OrderKeys.lastAccessedAt,
        getMenuItemDisplayValue: Messages.sortByOldest,
        getButtonDisplayValue: Messages.sortLastAccessedAtOldest,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.lastAccessedAt)]
      }
    }
  }
};
